"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", { value: true });
var x25519_1 = require("@stablelib/x25519");
var xsalsa20_1 = require("@stablelib/xsalsa20");
var secretbox_1 = require("./secretbox");
var wipe_1 = require("@stablelib/wipe");
var x25519_2 = require("@stablelib/x25519");
exports.generateKeyPair = x25519_2.generateKeyPair;
var zeros16 = new Uint8Array(16);
function precomputeSharedKey(theirPublicKey, mySecretKey) {
    // Compute scalar multiplication result.
    var key = x25519_1.scalarMult(mySecretKey, theirPublicKey);
    // Hash key with HSalsa function.
    xsalsa20_1.hsalsa(key, zeros16, key);
    return key;
}
exports.precomputeSharedKey = precomputeSharedKey;
function box(theirPublicKey, mySecretKey, nonce, data) {
    var sharedKey = precomputeSharedKey(theirPublicKey, mySecretKey);
    var result = secretbox_1.secretBox(sharedKey, nonce, data);
    wipe_1.wipe(sharedKey);
    return result;
}
exports.box = box;
function openBox(theirPublicKey, mySecretKey, nonce, data) {
    var sharedKey = precomputeSharedKey(theirPublicKey, mySecretKey);
    var result = secretbox_1.openSecretBox(sharedKey, nonce, data);
    wipe_1.wipe(sharedKey);
    return result;
}
exports.openBox = openBox;
//# sourceMappingURL=box.js.map